module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_location_maedori@3x-1d85cfadad4e1ca766eb80bb7e219f9c.webp";